import { createReducer, on } from '@ngrx/store';
import { tokensInitialState } from '../initial-states/tokens.state';
import { loadTokens, loadTokensFailed, loadTokensSuccess, updateTokens } from '../actions/tokens.actions';

export const TokensReducer = createReducer(
    tokensInitialState,
    on(loadTokens, (state) => ({ ...state, loading: true })),
    on(loadTokensSuccess, (state, { tokenBalance }) => {
        const current = tokenBalance?.currentTokenBalance ?? null;
        const total = tokenBalance?.monthlyToken ?? null;
        const percent = computeTokenPercent(current, total);
        return { ...state, loading: false, value: { tokenBalance: tokenBalance ?? null, tokenSummary: { current, total, percent } }, error: undefined, loadedOnce: true };
    }),
    on(loadTokensFailed, (state, { error }) => ({ ...state, loading: false, error })),
    on(updateTokens, (state, { tokenBalance }) => {
        const current = tokenBalance?.currentTokenBalance ?? null;
        const total = tokenBalance?.monthlyToken ?? null;
        const percent = computeTokenPercent(current, total);
        return { ...state, value: { tokenBalance: tokenBalance ?? null, tokenSummary: { current, total, percent } } };
    })
)

function computeTokenPercent(current: number | null | undefined, total: number | null | undefined): number {
    const c = Number(current ?? 0);
    const t = Number(total ?? 0);
    if (t <= 0) return 0;
    const raw = (c / t) * 100;
    const rounded = Math.round(raw);
    return Math.max(0, Math.min(100, rounded));
}

